/**
 * Стиль кластеров в виде правил
 */
export const DFAULT_CLUSTER_STYLE_RULES = [
  {
    id: 'cluster10',
    name: 'Кластер до 10 объектов',
    filter: ['all', ['>', ['get', 'count'], 1], ['<=', ['get', 'count'], 10]],
    style: [
      {
        type: 'CircleMarker',
        options: {
          stroke: false,
          radius: 35,
          fillOpacity: 0.3,
          fillColor: '#a0cf75'
        }
      },
      {
        type: 'CircleMarkerText',
        options: {
          fillColor: '#a0cf75',
          fillOpacity: 1,
          stroke: false,
          radius: 26,
          textColor: '#2F3541',
          fontFamily: 'Roboto, sans-serif',
          fontSize: 16,
          fontSizeUnits: 'px',
          text: ['get', 'count']
        }
      }
    ]
  },
  {
    id: 'cluster100',
    name: 'Кластер до 100 объектов',
    filter: ['all', ['>', ['get', 'count'], 10], ['<=', ['get', 'count'], 100]],
    style: [
      {
        type: 'CircleMarker',
        options: {
          stroke: false,
          radius: 35,
          fillOpacity: 0.3,
          fillColor: '#e7c961'
        }
      },
      {
        type: 'CircleMarkerText',
        options: {
          fillColor: '#e7c961',
          fillOpacity: 1,
          stroke: false,
          radius: 26,
          textColor: '#2F3541',
          fontFamily: 'Roboto, sans-serif',
          fontSize: 16,
          fontSizeUnits: 'px',
          text: ['get', 'count']
        }
      }
    ]
  },
  {
    id: 'cluster-more-100',
    name: 'Кластер более 100 объектов',
    filter: ['>', ['get', 'count'], 100],
    style: [
      {
        type: 'CircleMarker',
        options: {
          stroke: false,
          radius: 35,
          fillOpacity: 0.3,
          fillColor: '#e4995e'
        }
      },
      {
        type: 'CircleMarkerText',
        options: {
          fillColor: '#e4995e',
          fillOpacity: 1,
          stroke: false,
          radius: 26,
          textColor: '#2F3541',
          fontFamily: 'Roboto, sans-serif',
          fontSize: 16,
          fontSizeUnits: 'px',
          text: ['get', 'count']
        }
      }
    ]
  }
]

/**
 * Старый вариант кластеров в виде массива стилей с выражениями для свойств
 */
export const DEFAULT_CLUSTER_STYLE = [
  {
    type: 'CircleMarker',
    filter: ['>', ['get', 'count'], 1],
    options: {
      stroke: false,
      radius: 35,
      fillOpacity: 0.3,
      fillColor: ['case', ['<=', ['get', 'count'], 10], '#a0cf75', ['>', ['get', 'count'], 100], '#e4995e', '#e7c961']
    }
  },
  {
    type: 'CircleMarkerText',
    filter: ['>', ['get', 'count'], 1],
    options: {
      fillColor: ['case', ['<=', ['get', 'count'], 10], '#a0cf75', ['>', ['get', 'count'], 100], '#e4995e', '#e7c961'],
      fillOpacity: 1,
      stroke: false,
      radius: 26,
      textColor: '#2F3541',
      fontFamily: 'Roboto, sans-serif',
      fontSize: 16,
      fontSizeUnits: 'px',
      text: ['get', 'count']
    }
  }
]

/**Стиль потока с предметами, когда нет предметов (массив items у потока пустой) */
export const DEFAULT_NON_ITEM_FLOW_LINE = [
  {
    type: 'PolylineDecorated',
    options: {
      color: 'transparent',
      bubblingMouseEvents: false,
      weight: 5,
      decorator: {
        overlapTreshhold: 0,
        offset: 100,
        endOffset: 0,
        repeat: 200,
        type: 'CanvasMarker',
        options: {
          img: {
            icon: 'flow-direction',
            rotate: 0,
            offset: { x: 0, y: 0 },
            size: ['coalesce', ['get', 'iconSize'], ['literal', [5, 5]]]
          }
        }
      }
    }
  }
]

/**
 * Специальный стиль линии предмета потока
 */
export const DEFAULT_FLOW_ITEM_LINE_STYLE = [
  {
    type: 'Polyline',
    options: {
      weight: 5,
      offset: 0,
      color: '#a0cf75'
    }
  }
]

export const DEFAULT_FLOW_DECORATION_LINE_STYLE = [
  {
    type: 'PolylineDecorated',
    options: {
      color: 'transparent',
      bubblingMouseEvents: false,
      decorator: {
        overlapTreshhold: 0,
        offset: 100,
        endOffset: 0,
        repeat: 200,
        type: 'CanvasMarker',
        options: {
          img: {
            icon: 'flow-direction',
            rotate: 0,
            offset: { x: 0, y: 0 },
            size: ['coalesce', ['get', 'iconSize'], ['literal', [6, 6]]]
          }
        }
      }
    }
  }
]

export default {
  emitter: [
    {
      type: 'CircleMarker',
      filter: ['==', ['get', 'count'], 1],
      options: {
        fillColor: '#db3283'
      }
    },
    ...DEFAULT_CLUSTER_STYLE
  ],

  containerplatform: [
    {
      id: 'imported',
      name: 'Импортированные',
      filter: ['all', ['==', ['get', 'count'], 1], ['==', ['get', 'imported'], true]],
      style: {
        type: 'CircleMarker',
        options: {
          fillColor: '#56CCF2'
        }
      }
    },
    {
      id: 'createdByModel',
      name: 'Сформированы при моделировании',
      filter: ['all', ['==', ['get', 'count'], 1], ['==', ['get', 'imported'], false]],
      style: {
        type: 'CircleMarker',
        options: {
          fillColor: '#E2F025'
        }
      }
    },
    {
      id: 'cluster10',
      name: 'Кластер до 10 объектов',
      filter: ['all', ['>', ['get', 'count'], 1], ['<=', ['get', 'count'], 10]],
      /**Спрятать правило при формировании легенды */
      hideInMapLegend: true,
      style: [
        {
          type: 'CircleMarker',
          options: {
            stroke: false,
            radius: 35,
            fillOpacity: 0.3,
            fillColor: '#a0cf75'
          }
        },
        {
          type: 'CircleMarkerText',
          options: {
            fillColor: '#a0cf75',
            fillOpacity: 1,
            stroke: false,
            radius: 26,
            textColor: '#2F3541',
            fontFamily: 'Roboto, sans-serif',
            fontSize: 16,
            fontSizeUnits: 'px',
            text: ['get', 'count']
          }
        }
      ]
    },
    {
      id: 'cluster100',
      name: 'Кластер до 100 объектов',
      filter: ['all', ['>', ['get', 'count'], 10], ['<=', ['get', 'count'], 100]],
      /**Спрятать правило при формировании легенды */
      hideInMapLegend: true,
      style: [
        {
          type: 'CircleMarker',
          options: {
            stroke: false,
            radius: 35,
            fillOpacity: 0.3,
            fillColor: '#e7c961'
          }
        },
        {
          type: 'CircleMarkerText',
          options: {
            fillColor: '#e7c961',
            fillOpacity: 1,
            stroke: false,
            radius: 26,
            textColor: '#2F3541',
            fontFamily: 'Roboto, sans-serif',
            fontSize: 16,
            fontSizeUnits: 'px',
            text: ['get', 'count']
          }
        }
      ]
    },
    {
      id: 'cluster-more-100',
      name: 'Кластер более 100 объектов',
      filter: ['>', ['get', 'count'], 100],
      /**Спрятать правило при формировании легенды */
      hideInMapLegend: true,
      style: [
        {
          type: 'CircleMarker',
          options: {
            stroke: false,
            radius: 35,
            fillOpacity: 0.3,
            fillColor: '#e4995e'
          }
        },
        {
          type: 'CircleMarkerText',
          options: {
            fillColor: '#e4995e',
            fillOpacity: 1,
            stroke: false,
            radius: 26,
            textColor: '#2F3541',
            fontFamily: 'Roboto, sans-serif',
            fontSize: 16,
            fontSizeUnits: 'px',
            text: ['get', 'count']
          }
        }
      ]
    }
  ],

  transportbase: [
    {
      type: 'CanvasMarker',
      filter: ['==', ['get', 'count'], 1],
      options: {
        img: {
          icon: 'transportbase',
          size: ['literal', [46, 46]]
        }
      }
    },
    ...DEFAULT_CLUSTER_STYLE
  ],

  building: [
    {
      type: 'CircleMarker',
      filter: ['==', ['get', 'count'], 1],
      options: {
        fillColor: ['coalesce', ['get', 'color'], '#33d85e']
      }
    },
    ...DEFAULT_CLUSTER_STYLE
  ],

  collectingloop: {
    type: 'Polyline',
    options: {
      color: 'red',
      weight: ['case', ['==', ['get', 'isSelected'], true], 5, 1],
      lineCap: ['case', ['==', ['get', 'isSelected'], true], 'square', 'round'],
      dashArray: ['case', ['==', ['get', 'isSelected'], true], '1 10', '1, 4'],
      bubblingMouseEvents: false
    }
  },

  transfer: {
    type: 'Polyline',
    options: {
      color: 'red',
      weight: ['case', ['==', ['get', 'isSelected'], true], 7, 2],
      lineCap: ['case', ['==', ['get', 'isSelected'], true], 'square', 'round'],
      dashArray: ['case', ['==', ['get', 'isSelected'], true], '7 14', '4, 6'],
      bubblingMouseEvents: false
    }
  },

  removaltrip: {
    type: 'PolylineDecorated',
    options: {
      color: 'red',
      weight: ['case', ['==', ['get', 'isSelected'], true], 10, 2],
      lineCap: ['case', ['==', ['get', 'isSelected'], true], 'square', 'round'],
      dashArray: ['case', ['==', ['get', 'isSelected'], true], '', '6, 6, 1, 6'],
      bubblingMouseEvents: false,
      decorator: {
        offset: 0,
        endOffset: 0,
        repeat: 250,
        type: 'CanvasMarker',
        options: {
          img: {
            icon: 'direction',
            size: ['literal', [19, 18]],
            rotate: 0,
            offset: { x: 0, y: 0 }
          }
        }
      }
    }
  },

  source: {
    type: 'CircleMarker',
    options: {
      radius: 5,
      stroke: true,
      weight: 2,
      color: '#fff',
      fill: true,
      fillColor: ['coalesce', ['get', 'color'], '#0288F3'],
      fillOpacity: 1
    }
  },

  flow: [
    {
      type: 'Polyline',
      filter: ['==', ['get', 'state'], 'flow-animated'],
      options: {
        weight: ['case', ['==', ['get', 'isSelected'], true], 5, 2],
        color: ['coalesce', ['get', 'color'], ['get', 'treatment_color']]
      }
    },
    {
      type: 'PolylineDecorated',
      filter: ['==', ['get', 'state'], 'flow-static'],
      options: {
        color: ['coalesce', ['get', 'color'], ['get', 'treatment_color']],
        weight: ['case', ['==', ['get', 'isSelected'], true], 8, 4],
        bubblingMouseEvents: false,
        decorator: {
          overlapTreshhold: 0,
          offset: 100,
          endOffset: 0,
          repeat: 200,
          type: 'CanvasMarker',
          options: {
            img: {
              icon: 'flow-direction',
              rotate: 0,
              offset: { x: 0, y: 0 },
              size: ['case', ['==', ['get', 'isSelected'], true], ['literal', [10, 10]], ['literal', [6, 6]]]
            }
          }
        }
      }
    }
  ],

  /**Специальный стиль линии предмета потока */
  flowItemLine: DEFAULT_FLOW_ITEM_LINE_STYLE,

  /**Специальный стиль декорирующей линии (белые уголки на линии) для декорирования линий потоков с предметами */
  flowItemLineDecorated: DEFAULT_FLOW_DECORATION_LINE_STYLE,

  /**Специальный стиль для маршрутов линейных информационных слоев */
  streaminfoRoute: {
    type: 'GeoJSON',
    options: {
      interactive: false,
      bubblingMouseEvents: false,
      style: {
        color: '#ff0000',
        weight: 1,
        opacity: 1
      }
    }
  },

  removalTripMVT: {
    type: 'VectorTile',
    options: {
      default: {
        type: 'PolylineDecorated',
        options: {
          weight: 2,
          color: 'red',
          dashArray: '6, 6, 1, 6',
          decorator: {
            offset: 0,
            endOffset: 0,
            repeat: 500,
            type: 'CanvasMarker',
            options: {
              img: {
                icon: 'direction',
                size: ['literal', [19, 18]],
                rotate: 0,
                offset: { x: 0, y: 0 }
              }
            }
          }
        }
      }
    }
  },

  removalTripMVTSelected: {
    default: {
      type: 'PolylineDecorated',
      options: {
        color: 'red',
        weight: 10,
        lineCap: 'square',
        dashArray: ''
      }
    }
  },

  transferMVT: {
    type: 'VectorTile',
    options: {
      default: {
        type: 'PolylineDecorated',
        options: {
          color: 'red',
          weight: 2,
          lineCap: 'round',
          dashArray: '4, 6'
        }
      }
    }
  },

  transferMVTSelected: {
    default: {
      type: 'PolylineDecorated',
      options: {
        color: 'red',
        weight: 10,
        lineCap: 'square',
        dashArray: ''
      }
    }
  },

  collectingLoopMVT: {
    type: 'VectorTile',
    options: {
      default: {
        type: 'PolylineDecorated',
        options: {
          weight: 1,
          color: 'red',
          lineCap: 'round',
          dashArray: '1, 4'
        }
      }
    }
  },

  collectingLoopMVTSelected: {
    default: {
      type: 'PolylineDecorated',
      options: {
        color: 'red',
        weight: 10,
        lineCap: 'square',
        dashArray: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/objects/defaultLayerStyles.js